export function getApiDomain() {
    const environment = document.querySelector("[data-environment]")?.getAttribute("data-environment");

    if (!environment) {
        throw new Error("Environment element [data-environment] is missing or empty");
    }

    return environment === "production"
        ? "https://api.smartling.com"
        : "https://api.stg.smartling.net";
}
